export const shouldPromptCreatePassword = ({ isInitialized, user } = {}) => {
  if (!isInitialized || !user) return false;

  // A conta que entra pelo Google nasce sem senha por decisão do produto: o
  // provedor substitui a senha. `!== true` mantém o pedido enquanto o back não mandar o campo.
  return user.has_usable_password === false && user.has_social_login !== true;
};

export default function useShouldPromptCreatePassword({ isInitialized, user } = {}) {
  return shouldPromptCreatePassword({ isInitialized, user });
}
